module.exports = __webpack_public_path__ + "img/conversion-select.f94ceb45.svg";